import { MOBILE_VIEWPORT } from "@/shared/constants/ui.constant";

export const VIEWPORT_WIDTH = document.documentElement.clientWidth;
export const IS_MOBILE_VIEWPORT = window.matchMedia(
  `(max-width: ${MOBILE_VIEWPORT}px)`,
).matches;
